import angular from 'angular';

module.exports = angular.module('common.components.od-document-preview', [])
.component('odDocumentPreview', {
  bindings: {
    documentItem: '<',
  },
  template: require('./od-document-preview.jade')(),
  controller: class {
    constructor($uibModal) {
      this.$uibModal = $uibModal;
    }

    showPreviewModal() {
      let documentItem = this.documentItem;

      return this.$uibModal.open({
        size: 'lg',
        template: require('tools/components/od-document-table/document-preview-modal.jade')(),
        windowClass: 'document-preview-modal',
        controllerAs: 'modalCtrl',
        controller: /*@ngInject*/ class {
          constructor($uibModalInstance, $sce) {
            this.$uibModalInstance = $uibModalInstance;
            this.url = $sce.trustAsResourceUrl(
              `${documentItem.url}?response-content-disposition-type=inline`
            );
          }
        }
      });
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/od-document-preview.js
 **/